import React from 'react';

export default function QuotationScopeOfSupplyPage({ scopeOfSupply = {} }) {
  const items = scopeOfSupply.items || [];
  const valueAddition = scopeOfSupply.valueAddition || [];

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-no-break" style={{ marginBottom: 18 }}>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
            SCOPE OF SUPPLY
          </h2>
          <div className="quotation-yellow-divider" />
        </div>

        <div className="quotation-section-block">
        <table className="quotation-table" style={{ marginBottom: 18 }}>
          <thead>
            <tr>
              <th style={{ width: 80 }}>S. No.</th>
              <th>Item</th>
              <th style={{ width: 120 }}>Unit</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.sno}>
                <td>{row.sno}</td>
                <td>{row.item}</td>
                <td>{row.unit}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="quotation-section-block" style={{ background: '#f8f9fa', padding: 12, borderLeft: '3px solid #ffbe0b', marginTop: 14 }}>
          <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 14, color: '#000814', margin: '0 0 12px 0' }}>
            VALUE ADDITION WITH VACSPL
          </p>
          <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#333', lineHeight: 1.7 }}>
            {valueAddition.map((line, i) => (
              <li key={i} style={{ marginBottom: 6 }}>{line}</li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
  );
}
